import en from "config/strings/en";

function validateIsraeliId(idNumber) {
    // Check if the ID number is 9 digits long
    if (!/^\d{9}$/.test(idNumber)) {
        return false;
    }

    // Calculate the check digit
    const idDigits = idNumber?.toString()?.split('').map(Number);
    let sum = 0;

    idDigits.forEach((digit, index) => {
        let weight = (index % 2 === 0) ? 1 : 2;
        let result = digit * weight;
        if (result > 9) {
            result -= 9;
        }
        sum += result;
    });

    return sum % 10 === 0;
}

function validateIsraeliPassport(passportNumber) {
    if (!passportNumber) return false;

    passportNumber = passportNumber.toString().toUpperCase();

    // 8 digits OR letter + 7 digits
    const passportRegex = /^(\d{8}|[A-Z]\d{7})$/;

    return passportRegex.test(passportNumber);
}

function validatePassword(password) {
    if (!password || password.length < 8) {
        return "הסיסמא חייבת לכלול 8 תווים";
    }

    if (/^\d+$/.test(password)) {
        return "הסיסמא צריכה להכיל תווים נוספים מלבד מספרים";
    }

    return ""; // No error
}

function validateEmail(email) {
    let error = ""
    if (!email) {
        error = en.require('email')
    }
    else if (!email.match(/^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9_ ]+\.)+[a-zA-Z]{2,}))$/))
        error = en.invalidEmail

    return error
}

//מתאים רק לישראל 
function validatePhoneNumber(phoneNumber) {
    const valid = /^(02|03|04|08|09|050|052|053|054|055|056|057|058|059|072|073|074|075|076|077|078|079)[\-\s{1}]?\d{1}[\-\s{1}]?\d{6}$/.test(phoneNumber);
    if (valid)
        return null
    else return en.invalidPhone
}


function validateIsraeliIdOrPassport(value) {
    return (
        validateIsraeliId(value)
        //  ||
        // validateIsraeliPassport(value)
    );
}

export { validateIsraeliId, validateIsraeliIdOrPassport, validateIsraeliPassport, validatePhoneNumber, validateEmail, validatePassword }


